import React, { FC } from 'react';
import { ReactComponent as SlantingCheckMark } from '../../icons/slanting-checkmark.svg';
import ICtaVerticalChecklistBox from '../../interfaces/elements/ICtaVerticalChecklistBox';
import { Column, Columns } from '../base/grid';
import * as StyledCtaVerticalChecklistBoxes from './ctaVerticalChecklistBoxes.styles';

interface Props {
	title: string;
	list: ICtaVerticalChecklistBox[];
}

const CtaVerticalChecklistBoxes: FC<Props> = ({ title, list }) => {
	return (
		<StyledCtaVerticalChecklistBoxes.Wrapper>
			<StyledCtaVerticalChecklistBoxes.Title>{title}</StyledCtaVerticalChecklistBoxes.Title>
			<Columns>
				{list.map((listItem, index) => (
					<Column tablet={list.length > 1 ? 1 / 3 : 1} key={index}>
						<StyledCtaVerticalChecklistBoxes.TileWrapper>
							<StyledCtaVerticalChecklistBoxes.TileTitle>
								{listItem.Values.Title}
							</StyledCtaVerticalChecklistBoxes.TileTitle>
							<StyledCtaVerticalChecklistBoxes.TileChecklist>
								{listItem.Values.ItemList.map(item => (
									<StyledCtaVerticalChecklistBoxes.CheckedItem key={item}>
										<SlantingCheckMark />
										<span>{item}</span>
									</StyledCtaVerticalChecklistBoxes.CheckedItem>
								))}
							</StyledCtaVerticalChecklistBoxes.TileChecklist>
							{listItem.Values.DisclaimerText && (
								<StyledCtaVerticalChecklistBoxes.DisclaimerText
									dangerouslySetInnerHTML={{ __html: listItem.Values.DisclaimerText }}
								/>
							)}
							<StyledCtaVerticalChecklistBoxes.PriceWrapper>
								<StyledCtaVerticalChecklistBoxes.PriceString>
									{listItem.Values.PriceString}
								</StyledCtaVerticalChecklistBoxes.PriceString>
								<StyledCtaVerticalChecklistBoxes.Price>
									{listItem.Values.Price}
								</StyledCtaVerticalChecklistBoxes.Price>
							</StyledCtaVerticalChecklistBoxes.PriceWrapper>
							{listItem.Values.Link && (
								<StyledCtaVerticalChecklistBoxes.TileLink href={listItem.Values.Link.Url}>
									{listItem.Values.Link.Name}
								</StyledCtaVerticalChecklistBoxes.TileLink>
							)}
						</StyledCtaVerticalChecklistBoxes.TileWrapper>
					</Column>
				))}
			</Columns>
		</StyledCtaVerticalChecklistBoxes.Wrapper>
	);
};

export default CtaVerticalChecklistBoxes;
